import { get, post } from './client';
import { buildPath, toJson } from './utils';
import { ORDERS_PATH } from './constants';
import { GeneralListType, IdType } from './types';
import { OrderList } from './general/models';

const GENERATE_TICKET_PDF_PATH = 'generate-ticket-pdf';
const GENERATE_ADDON_PDF_PATH = 'generate-addon-pdf';
const RESEND_EMAIL_PATH = 'resend-email';

export const getOrders = (options: any): Promise<GeneralListType<OrderList>> =>
  get(buildPath(ORDERS_PATH), options).then(toJson);

// The order-detail endpoint can respond 200 with a genuinely empty body for an order that
// doesn't resolve to a real record (embedded-checkout race with payment webhook finalization,
// see JPA-8146/JPA-8180). `res.json()` throws SyntaxError on an empty body instead of returning
// undefined, which the saga would then treat as a generic fetch error rather than "not found" —
// parsing the raw text ourselves lets an empty response resolve to `undefined` so the order
// page's existing `isFetched && !entity` → not_found branch handles it correctly.
const toJsonOrUndefined = (res: Response): Promise<OrderList | undefined> =>
  res.text().then((text) => (text ? JSON.parse(text) : undefined));

export const getOrder = (orderId: IdType, options: any): Promise<OrderList | undefined> =>
  get(buildPath(ORDERS_PATH, orderId), options).then(toJsonOrUndefined);

export const getTicketPdf = (orderId: IdType, ticketId: IdType, options: any) =>
  get(buildPath(ORDERS_PATH, orderId, GENERATE_TICKET_PDF_PATH, ticketId), options);

export const getAddonPdf = (orderId: IdType, addonId: IdType, options: any) =>
  get(buildPath(ORDERS_PATH, orderId, GENERATE_ADDON_PDF_PATH, addonId), options);

export const resendEmail = (orderId: IdType, options: any) =>
  post(buildPath(ORDERS_PATH, orderId, RESEND_EMAIL_PATH), options);
